import { render, staticRenderFns } from "./ContractStatus.vue?vue&type=template&id=0c8b15b2&scoped=true"
import script from "./ContractStatus.vue?vue&type=script&lang=js"
export * from "./ContractStatus.vue?vue&type=script&lang=js"
import style0 from "./ContractStatus.vue?vue&type=style&index=0&id=0c8b15b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b15b2",
  null
  
)

export default component.exports